//@flow
import { useMediaQuery } from "@mui/material";
import React, { useContext, useEffect } from 'react';
import Box from "@mui/material/Box";
import useMenuAction from "../../../hooks/menu/useMenuAction";
import useMenuData from "../../../hooks/menu/useMenuData";
import Toolbar from "@mui/material/Toolbar";
import { Title } from "../../../pages/main/common";
import { TitleContext } from "../../../pages/main/content";
import useConfig from "../../../themes/hooks/useConfig";
import Drawer from "../drawer/drawer";
import Header from "../header/header";
import { useTheme } from "@mui/material/styles";
import { Permissions } from "../../../helpers/constants";
import { useHasPermission } from "../../../modules/permission/hooks/useHasPermission";
import NoDrawerLayout from "../noDrawerLayout/noDrawerLayout";

const MenuWithDrawer = (props) => {
	const {toolbar} = useContext(TitleContext)
	const theme = useTheme();
	const { drawerOpen } = useMenuData()
	const { setDrawerOpen } = useMenuAction()
	const { miniDrawer } = useConfig();
	const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], { shouldView: true })
	const isHome = window.location.pathname === "/"
	const shouldDisplayDrawer = (isOrganizer || (!isOrganizer && !isHome))
	
	// set media wise responsive drawer
	useEffect(() => {
		if (!miniDrawer && drawerOpen) {
			setDrawerOpen(!matchDownLG)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [matchDownLG]);
	
	return (
		<Box>
			{downSM && !isOrganizer && (
				<Box sx={{ textAlign: 'center', backgroundColor: theme.palette.highlight[50] }}>
					<Title/>
				</Box>
			)}
			<Box sx={{ width: '100%', display: 'flex' }}>
				{shouldDisplayDrawer ? (
					<>
						<Header/>
						<Drawer/>
					</>
				) : (
					<NoDrawerLayout color={theme.palette.white.main}/>
				)}
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						p: 2,
						pt: downSM ? 6 : 4,
						overflowX: 'auto'
					}}
				>
					<Toolbar variant={"dense"}/>
					{downSM && isOrganizer && (
						<Box sx={{ textAlign: 'center', backgroundColor: theme.palette.highlight[50] }}>
							<Title/>
						</Box>
					)}
					{toolbar && (
						<Toolbar variant={"dense"}>
							{toolbar}
						</Toolbar>
					)}
					{props.children}
				</Box>
			</Box>
		</Box>
	
	)
}

export default MenuWithDrawer;